import { useQuery } from 'react-query';

import { DocChronologySummary } from '../../../../backend/src/case/chronology/doc-chronology/dto/get-doc-chronologies-response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetDocChronologies = ({ matterId, subsetId }: { matterId: string; subsetId: string }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<DocChronologySummary[]>(
    [QueryEntity.DocChronologies, { subsetId }],
    () => {
      return fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-chronology`,
        fetchConfigGET,
      ).then((res) => {
        return res.json();
      });
    },
    { enabled: !!matterId && !!subsetId },
  );
};
